import { newHoursValidator } from '@pay-bill/services';
import { Cascader, Form, FormInstance } from 'antd';
import React from 'react';
import { iterationMap } from 'works/legacy/services/iteration-service';

const rules = [{ required: true, validator: newHoursValidator }];

export const DisputeHoursInput = ({ form }: { form: FormInstance }) => {
  const minutesOptions = iterationMap(60, (minute) => {
    return {
      label: `${minute} min`,
      floating: minute / 60,
    };
  });

  const options = iterationMap(24, (hour) => {
    return {
      label: `${hour} hrs`,
      value: hour.toString(),
      children: minutesOptions.map((minute) => ({
        value: hour + minute.floating,
        ...minute,
      })),
    };
  });

  const handleChange = (value: (string | number)[]) => {
    const newHours = value ? Number(value[1]) : value;
    form.setFieldsValue({ newHours });
  };

  return (
    <Form.Item name="newHours" rules={rules}>
      <Cascader
        size="large"
        onChange={handleChange}
        placeholder="Hours"
        getPopupContainer={(trigger) => trigger.parentNode}
        options={options}
        displayRender={(selectedOption) =>
          `${selectedOption.toLocaleString('fullwide', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} hrs`
        }
        expandIcon={<></>}
        style={{ width: '110px' }}
      />
    </Form.Item>
  );
};
